.label {
  font-weight: var(--semibold);
  text-align: left;
}

.label--required::after {
  color: var(--color-red-600);
  content: "\2605";
  font-size: 0.5rem;
  margin-left: 0.25rem;
  vertical-align: top;
}

.label--unset-font-weight {
  font-weight: unset;
}

.label--align-right {
  text-align: right;
}
